import {
  Component,
  OnInit,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../user.service';
import { Chart } from 'chart.js';
//import { WindowRef } from './WindowRef';

@Component({
  selector: 'app-userprofile',
  templateUrl: './userprofile.component.html'
})
export class UserprofileComponent implements OnInit {
  constructor(
    private userService: UserService,
    private router: Router,
    private elementRef: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  name = '';

  lab_number = 1;

  testchart = '1';

  myChart: any;

  ngOnInit() {
    this.name = this.userService.fullname;
    this.setLabNumber(1);
  }

  ngOnChanges() {}

/*
  aws_op_dashboard() {
    this.router.navigate(['/dashboard']);
  }
  */

  setLabNumber(num) {
    this.lab_number = num;
    this.changeDetectorRef.detectChanges();
    const htmlRef = this.elementRef.nativeElement.querySelector(
      `#doughnutChartCustom${num}`,
    );
    this.myChart = new Chart(htmlRef, this.getChartData(num));



  }


  /*

  	[class.active]="variable === el_id" (click)="variable=el_id"


  	navItem

  	this.

  	left-nav-item-1-id


*/



  getChartData(num) {
    if (num === 1) {
      return {
        type: 'doughnut',
        options: {
          cutoutPercentage: 80,
          legend: {
            display: true,
            position: 'left',
          },
        },
        data: {
          labels: ['Difficulty'],
          datasets: [
            {
              data: [340, 20],
              borderWidth: [0, 0, 0, 0],
              backgroundColor: ['#2291d0', '#ffffff'],
              hoverBackgroundColor: ['#2291d0', '#ffffff'],
            },
          ],
        },
      };
    } else if (num === 2) {
      return {
        type: 'doughnut',
        options: {
          cutoutPercentage: 80,
          legend: {
            display: true,
            position: 'left',
          },
        },
        data: {
          labels: ['Difficulty'],
          datasets: [
            {
              data: [20, 340],
              borderWidth: [0, 0, 0, 0],
              backgroundColor: ['#2291d0', '#ffffff'],
              hoverBackgroundColor: ['#2291d0', '#ffffff'],
            },
          ],
        },
      };
    } else if (num === 3) {
      return {
        type: 'doughnut',
        options: {
          cutoutPercentage: 80,
          legend: {
            display: true,
            position: 'left',
          },
        },
        data: {
          labels: ['Difficulty'],
          datasets: [
            {
              data: [120, 20],
              borderWidth: [0, 0, 0, 0],
              backgroundColor: ['#2291d0', '#ffffff'],
              hoverBackgroundColor: ['#2291d0', '#ffffff'],
            },
          ],
        },
      };
} else if (num === 4) {




} else if (num === 5) {




} else if (num === 6) {





} else if (num === 7) {



} else if (num === 8) {





} else {
      return {};
    }
  }

  logout() {
    this.userService.fullname = '';
    this.userService.user = null;
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// ./src/app/userprofile/userprofile.component.ts